import { HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AppHelper } from '@shared-helpers/appHelper';
import { DateConverter } from '@shared-helpers/dateConverter';
import { MemberLoginRequestResult } from '@shared-results/member/MemberLoginRequestResult';
import { ServiceOperationOutcome } from '@shared-results/ServiceOperationOutcome';
import { BaseHttpService } from '@shared-services/base-http-service';
import { MemberService } from '@shared-services/member.service';
import { Observer } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root' // Single instance provided in root
})
export class LoginService extends BaseHttpService {
  private loginUrl = '/login/';

  private memberService = inject(MemberService);

  constructor() { super("LoginService"); }

  loginRequest(loginEmail: string, loginPassword: string, token: string, observerOrNext?: Partial<Observer<MemberLoginRequestResult>> | ((value: MemberLoginRequestResult) => void)): void {
    let options = BaseHttpService.getHttpOptions({ [AppHelper.requestVerificationTokenKey]: token });
    let optionsWithResponseObserver = BaseHttpService.getHttpOptionsWithResponseObserver(options);
    let url: string = `${this.loginUrl}LoginRequestV2`;
    let body: string = JSON.stringify({ UserName: loginEmail, Password: loginPassword });
    let bodyObscured: string = JSON.stringify({ UserName: loginEmail, Password: AppHelper.obscureSensitiveData(loginPassword) });

    let client = this.http?.post<MemberLoginRequestResult>(url, body, optionsWithResponseObserver).pipe(
      timeout(this.httpTimeout),
      map((response: HttpResponse<MemberLoginRequestResult>) => {
        let rawBody: MemberLoginRequestResult = response?.body;
        if (rawBody) {
          // Response body is not blank
          if (!(rawBody.VerificationToken)) {
            // Set token from response header
            rawBody.VerificationToken = response.headers?.get(AppHelper.requestVerificationTokenKey);
          }
        }
        return rawBody;
      }),
      map((item) => DateConverter.stringsToDates(item)),
      catchError(this.errorService?.handleHttpError<MemberLoginRequestResult>(url, bodyObscured, options, this))
    );
    this.addSubscriptions(client, observerOrNext, (result) => {
      if (result?.ServiceOperationOutcome == ServiceOperationOutcome.Success) {
        // Request succeeded
        if (result?.MemberData) {
          this.memberService?.cacheMemberData(result?.MemberData);
        }
        else {
          // No member data, trigger a refresh but don't wait for it
          this.memberService?.refreshMember()?.unsubscribe();
        }
      }
    });
  }

}
